import { Directive, OnInit } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';

@Directive({
// tslint:disable-next-line: directive-selector
  selector: 'mat-datepicker',
})
export class TouchUiAttrInjectorDirective implements OnInit {

  constructor(private matDatepicker: MatDatepicker<moment.Moment>) {
  }

  ngOnInit(): void {
    this.matDatepicker.touchUi = true;
  }

}
